// _PRACM_SHA stands for Predicted Risk Assuming Conservative Management - Surviving Heart Attack

// noinspection UnnecessaryLocalVariableJS

import {_PRAIP_SHA} from './PRAIP_SHA';
import {FACTOR} from './eqConstants';

export const _PRACM_SHA = patientHealthFactors => {
  const PRIData = _PRAIP_SHA(patientHealthFactors);
  const predictedRiskConservative = PRIData.PRI * FACTOR.conservativeMgmt;

  const survivingNextYear = {
    PRC: predictedRiskConservative,
    mortality: 1 - predictedRiskConservative,
    probability: (1 - predictedRiskConservative) * 100
  };

  return survivingNextYear;
};
